import { render, staticRenderFns } from "./administration-request.vue?vue&type=template&id=6a191a1e"
import script from "./administration-request.vue?vue&type=script&lang=js"
export * from "./administration-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports